module.exports = __webpack_public_path__ + "img/banner.d800e912.png";